import {
  CALL_OUTBOUND_PREAUTH_REQUEST,
  CALL_OUTBOUND_PREAUTH_SUCCESS,
  CALL_OUTBOUND_PREAUTH_FAILURE,
} from "./actionType";

const initialState = {
  loading: false,
  preauthData: null,
  error: null,
};

const twilioReducer = (state = initialState, action) => {
  switch (action.type) {
    case CALL_OUTBOUND_PREAUTH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CALL_OUTBOUND_PREAUTH_SUCCESS:
      return {
        ...state,
        loading: false,
        preauthData: action.payload,
      };
    case CALL_OUTBOUND_PREAUTH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default twilioReducer;
